
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_4808_8265)"}},[_c('path',{attrs:{"d":"M14.148 18.772a.857.857 0 001.31-.426l.266-.816a1.15 1.15 0 01.726-.729l.833-.27a.866.866 0 00.576-.813.858.858 0 00-.602-.818l-.818-.265a1.148 1.148 0 01-.728-.727l-.272-.83a.857.857 0 00-1.624.01l-.267.82a1.15 1.15 0 01-.71.726l-.832.27a.867.867 0 00-.577.813.857.857 0 00.588.813l.817.266a1.146 1.146 0 01.729.73l.27.831c.06.168.17.313.315.415z","fill":"#F2994A"}}),_c('path',{attrs:{"d":"M6.215 15.415a1.144 1.144 0 001.709-.475l.54-1.646a2.69 2.69 0 011.7-1.702l1.573-.511a1.14 1.14 0 00-.044-2.17l-1.558-.506a2.685 2.685 0 01-1.701-1.698l-.511-1.574a1.141 1.141 0 00-.418-.552 1.163 1.163 0 00-1.32 0 1.145 1.145 0 00-.422.563l-.518 1.593a2.685 2.685 0 01-1.658 1.667l-1.575.511a1.143 1.143 0 00.014 2.162l1.558.506c.505.17.95.485 1.277.905.187.241.33.512.426.802l.511 1.572c.08.223.225.417.419.553h-.002z","fill":"#7879F1"}}),_c('path',{attrs:{"d":"M14.614 7.378a.666.666 0 001.019-.332l.206-.635a.892.892 0 01.565-.566l.648-.21a.674.674 0 00.448-.632.667.667 0 00-.469-.637l-.635-.205a.893.893 0 01-.567-.566l-.21-.646a.667.667 0 00-1.264.009l-.208.636a.895.895 0 01-.551.565l-.648.21a.674.674 0 00-.448.633.667.667 0 00.457.632l.635.207a.892.892 0 01.567.568l.21.646c.046.13.132.243.245.323z","fill":"#F2C94C"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_4808_8265"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    